export const buttonColorYellow = "rgb(255, 160, 0)";
export const buttonColorYellowHover = "rgb(240, 150, 0)";
export const colorBasicPlan = "rgb(248, 14, 38)";
export const colorStandardPlan = "rgb(255, 178, 0)";
export const colorPremiumPlan = "rgb(71, 132, 255)";
export const purpleBgColor = "rgb(155, 116, 234)";
